import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class TechSpecsService {
    http;
    apiUrl = `${environment.base}/tech-specs`;
    constructor(http) {
        this.http = http;
    }
    findAll(ctx) {
        return this.http.get(this.apiUrl, { params: ctx });
    }
    findOne(id) {
        return this.http.get(`${this.apiUrl}/${id}`);
    }
    create(techSpec) {
        return this.http.post(this.apiUrl, techSpec);
    }
    update(id, techSpec) {
        return this.http.patch(`${this.apiUrl}/${id}`, techSpec);
    }
    remove(id) {
        return this.http.delete(`${this.apiUrl}/${id}`);
    }
    static ɵfac = function TechSpecsService_Factory(t) { return new (t || TechSpecsService)(i0.ɵɵinject(i1.HttpClient)); };
    static ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: TechSpecsService, factory: TechSpecsService.ɵfac, providedIn: 'root' });
}
